module.exports = __webpack_public_path__ + "img/img_driver_motor.a8b063ed.png";